import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=2f835b59&scoped=true&"
import script from "./DeleteModal.vue?vue&type=script&lang=js&"
export * from "./DeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DeleteModal.vue?vue&type=style&index=1&id=2f835b59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f835b59",
  null
  
)

export default component.exports